import React, { PureComponent } from 'react';
import { encodeForURI } from 'appSrc/utils';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AspectRatio from 'react-aspect-ratio';
import TextTruncate from 'react-text-truncate';
import { convertYouTubeIdToImg, parseYouTubeUrl } from 'appSrc/utils';
import ListCoverImage from 'appSrc/components/List/CoverImage';
import { UserAvatar, Icon } from 'appSrc/components/UI';
import TheaterPlayIcon from 'appSrc/components/Shards/Theater/PlayIcon';
import style from './styles/style.module.css';

class SmallArticleCard extends PureComponent {
    renderCoverImage = ( article ) => {
        var coverImage = article.cover_image || convertYouTubeIdToImg( parseYouTubeUrl( article.video_url ) );
        return (
            <ListCoverImage coverImage={ coverImage } />
        );
    }
    render() {
        const { article } = this.props;

        const articleUrl = `/app/articles/${ article.id }/${ encodeForURI(article.title) }`;
        const hasVideo = !!article.video_url;

        const author = article.author || {};
        const profession = ( author.profession || {} ).title;
        const desires = article.desires || [];
        const interests = article.interests || [];
        const category = interests[0] ? interests[0].interest : '';

        const movieMetaData = {
            attached_to: 'article_cover_video',
            attached_id: article.id,
            video_author_id: author.userid,
        };

        var countMessage = desires.length.toString() + ' Product';
        countMessage += desires.length > 1 ? 's' : '';


        return (
            <div className={ `${ style.smallArticleCard } ${ this.props.className }`.trim() }>
                <Link to={ articleUrl } className={ style.backgroundLink } title={ article.title }></Link>
                <div className={ style.cardContent }>
                    <AspectRatio ratio='10/9'
                    className={ style.aspectRatio }>
                        <div>
                            <div className={ style.imageWrapper }>
                                { this.renderCoverImage( article ) }
                            </div>
                            <div className={ style.overlayInfo }>
                                { hasVideo &&
                                    <TheaterPlayIcon className={ style.playButton } youtubeId={ parseYouTubeUrl( article.video_url ) }
                                    metaData={ movieMetaData } />
                                }
                                { desires.length > 0 &&
                                    <div className={ style.productCount }>
                                        <Icon source='customSvg' icon='bag' size={ 16 } />
                                        <span>{ countMessage }</span>
                                    </div>
                                }
                            </div>
                        </div>
                    </AspectRatio>
                    <div className={ style.cardInfo }>
                        <div className={ style.articleCategory } title={ category }>{ category }</div>
                        <TextTruncate text={ article.title }
                        title={ article.title } line={ 2 }
                        containerClassName={ style.articleTitle } />
                        <div className={ style.authorInfo }>
                            <UserAvatar src={ author.avatar } size={ 30 } />
                            <div className={ style.infoText }>
                                { profession &&
                                    <div className={ style.profession } title={ profession }>{ profession }</div>
                                }
                                <div className={ style.displayName } title={ author.displayName }>{ author.displayName }</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
SmallArticleCard.propTypes = {
    article: PropTypes.object.isRequired,
};
SmallArticleCard.defaultProps = {
    className: '',
};

export default SmallArticleCard;
